import React, { useCallback, useState } from 'react'
import DataGridV2 from '../../components/DataGridV2';
import { useTranslation } from 'react-i18next';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { useSelector } from 'react-redux';
import { INITIAL_ROW_SELECTION_MODEL } from '../../components/DataGridV2/constants';
import { formatDate, getLocalStorageItem, setLocalStorageItem } from '../../_helpers';
import { apps, LOCAL_STORAGE_GRID_KEYS } from '../../_constants';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { getBuyerRepairRequestColumns} from './utils';

const BuyerRepairRequestsGrid = ({ data }) => {
  const { t, i18n } = useTranslation()
  const apiRef = useGridApiRef();
  const classes = useStyles();
  const app = useSelector((state) => state.app);
  const keyPrefix = app === apps.aftercare ? "AFTERCARE" : "GENERAL";
  const [rowSelectionModel, setRowSelectionModel] = useState(INITIAL_ROW_SELECTION_MODEL);
  const [paginationModel, setPaginationModel] = useState(() => getLocalStorageItem(
    LOCAL_STORAGE_GRID_KEYS.BUYER_REPAIR_REQUESTS_PAGINATION[keyPrefix], undefined
  ))

  const processedData = data.map(item => ({
    ...item,
    id: item.requestId,
   }));

 const columns = getBuyerRepairRequestColumns({t,keyPrefix,i18n,apiRef}) 
  const onPaginationModelChange = useCallback((newPaginationModel) => {
    setPaginationModel(newPaginationModel)
    setLocalStorageItem(
      LOCAL_STORAGE_GRID_KEYS.BUYER_REPAIR_REQUESTS_PAGINATION[keyPrefix],
      newPaginationModel
    );
  }, [keyPrefix])

  const getBuyerRepairRequestsForPrintAndDownload = ({ isAllSelected = true, idsToExport = [] }) => {
    const userSelectedRows = isAllSelected ? processedData : idsToExport.map(id => processedData?.find(item => item?.requestId === id));
    const results = userSelectedRows?.map((item) => {
      let result = {}
      Object.keys(item).forEach((key) => {
        let value = item[key];
        const isDateField = columns.some(x => x.field === key && x.type === 'date');
        if (isDateField) {
          value = item[key] ? formatDate(new Date(item[key])) : "";
        }

        result[key] = value;
      });
      return result
    })
    return results;
  };

  return (
    <Box className={classes.mainContainer}>
      <DataGridV2
        localSearchIdentifier={LOCAL_STORAGE_GRID_KEYS.BUYER_REPAIR_REQUESTS_SEARCH_TEXT[keyPrefix]}
        localColumnFilterIdentifier={LOCAL_STORAGE_GRID_KEYS.BUYER_REPAIR_REQUESTS_COLUMN_FILTER[keyPrefix]}
        localColumnSortIdentifier={LOCAL_STORAGE_GRID_KEYS.BUYER_REPAIR_REQUESTS_COLUMN_SORT[keyPrefix]}
        localColumnOrderIdentifier={LOCAL_STORAGE_GRID_KEYS.BUYER_REPAIR_REQUESTS_COLUMN_ORDER[keyPrefix]}
        localColumnWidthIdentifier={LOCAL_STORAGE_GRID_KEYS.BUYER_REPAIR_REQUESTS_COLUMN_WIDTH[keyPrefix]}
        localColumnVisibilityIdentifier={LOCAL_STORAGE_GRID_KEYS.BUYER_REPAIR_REQUESTS_COLUMN_VISIBILITY[keyPrefix]}
        apiRef={apiRef}
        checkboxSelection
        rows={processedData}
        columns={columns}
        pagination
        filterMode="client"
        {...(!!paginationModel && { paginationModel })}
        onPaginationModelChange={onPaginationModelChange}
        rowSelectionModel={rowSelectionModel}
        onRowSelectionModelChange={(newRowSelectionModel) => {
          setRowSelectionModel(newRowSelectionModel);
        }}
        toolbarProps={{
          selectedRows: rowSelectionModel,
          getData: getBuyerRepairRequestsForPrintAndDownload,
          title: t('general.repairRequests')
        }}
      />
    </Box>
  )
}
const useStyles = makeStyles((theme) => ({
  mainContainer: {
    height: "100%",
    width: "100%",
    overflow: "hidden ",
    padding: 0,
  },
}));
export default BuyerRepairRequestsGrid
